
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/transactions/transactions-data",
      function () {
        return require("private-next-pages/docs/transactions/transactions-data.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/transactions/transactions-data"])
      });
    }
  